import { ContactRegistrationTypeHelper } from '..';

export const useContactRegistrationType = () => {
	let contactRegistrationTypeHelper = new ContactRegistrationTypeHelper();
	return {
		contactRegistrationTypeHelper,
		activeContactRegistrationType: contactRegistrationTypeHelper.active()
	};
};
